import { useMemo } from 'react';

import { useHouseholdDerived } from '../contexts/HouseholdContext';
import type { SampleLiability, SampleNetWorth } from '../types/financial';

export type LoanSnapshot = {
  mortgage: SampleLiability | null;
  hasMortgage: boolean;
};

export function pickPrimaryMortgage(netWorth: SampleNetWorth): SampleLiability | null {
  return (
    netWorth.liabilities.find((l) => l.type === 'mortgage') ??
    netWorth.liabilities.find((l) => (l.monthlyPayment ?? 0) > 0) ??
    null
  );
}

/**
 * Primary home-loan liability from derived household net worth.
 * Interest / principal always come from `estimatePaymentSplit` inside derive.
 */
export function useLoanSnapshot(netWorthOverride?: SampleNetWorth): LoanSnapshot {
  const derived = useHouseholdDerived();
  const netWorth = netWorthOverride ?? derived.netWorth;

  return useMemo(() => {
    const mortgage = pickPrimaryMortgage(netWorth);
    return { mortgage, hasMortgage: !!mortgage };
  }, [netWorth]);
}
